<div [formGroup]="group" class="check {{userClass}}">
  <label class="checkbox" *ngIf="name && group.controls[name]">
    <input
      type="checkbox"
      [formControl]="group.controls[name]"
      class="cheked"
      id="{{name}}"
      name="{{name}}"
      [disabled]="disabled"
      (ngModelChange)="onChange($event)" />
    <span> {{label}} </span>
    <div class="checkmark" tabindex="{{tabOrder}}" (keypress)="key($event)"></div>
  </label>
</div>
